import React, { useState } from 'react';
import OrganizationSettings from './OrganizationSettings';
import UserManagement from './UserManagement';
import RolePermissions from './RolePermissions';
import SystemConfig from './SystemConfig';
import BackupRestore from './BackupRestore';
import AuditLogs from './AuditLogs';
import EmailSmsSettings from './EmailSmsSettings';
import DepositSchemes from './DepositSchemes';
import ChartOfAccounts from './ChartOfAccounts';
import JournalEntries from './JournalEntries';
import FinancialReports from './FinancialReports';
import {
  BuildingOfficeIcon,
  UsersIcon,
  KeyIcon,
  Cog6ToothIcon,
  CloudArrowDownIcon,
  ClipboardDocumentListIcon,
  EnvelopeIcon,
  BanknotesIcon,
  DocumentTextIcon,
  BookOpenIcon,
  ChartBarIcon
} from '@heroicons/react/24/outline';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('organization');

  const tabs = [
    { id: 'organization', name: 'Organization', icon: BuildingOfficeIcon },
    { id: 'users', name: 'Users', icon: UsersIcon },
    { id: 'roles', name: 'Roles & Permissions', icon: KeyIcon },
    { id: 'deposit-schemes', name: 'Deposit Schemes', icon: BanknotesIcon },
    { id: 'chart-of-accounts', name: 'Chart of Accounts', icon: DocumentTextIcon },
    { id: 'journal-entries', name: 'Journal Entries', icon: BookOpenIcon },
    { id: 'financial-reports', name: 'Financial Reports', icon: ChartBarIcon },
    { id: 'system', name: 'System Config', icon: Cog6ToothIcon },
    { id: 'notifications', name: 'Email/SMS', icon: EnvelopeIcon },
    { id: 'backup', name: 'Backup & Restore', icon: CloudArrowDownIcon },
    { id: 'audit', name: 'Audit Logs', icon: ClipboardDocumentListIcon }
  ];

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">System Settings</h1>

      <div className="flex space-x-4 border-b mb-6 overflow-x-auto">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center px-4 py-2 font-medium whitespace-nowrap ${
              activeTab === tab.id
                ? 'text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            <tab.icon className="h-5 w-5 mr-2" />
            {tab.name}
          </button>
        ))}
      </div>

      <div className="bg-white rounded-lg shadow">
        {activeTab === 'organization' && <OrganizationSettings />}
        {activeTab === 'users' && <UserManagement />}
        {activeTab === 'roles' && <RolePermissions />}
        {activeTab === 'deposit-schemes' && <DepositSchemes />}
        {activeTab === 'chart-of-accounts' && <ChartOfAccounts />}
        {activeTab === 'journal-entries' && <JournalEntries />}
        {activeTab === 'financial-reports' && <FinancialReports />}
        {activeTab === 'system' && <SystemConfig />}
        {activeTab === 'notifications' && <EmailSmsSettings />}
        {activeTab === 'backup' && <BackupRestore />}
        {activeTab === 'audit' && <AuditLogs />}
      </div>
    </div>
  );
};

export default Settings;